var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 1.21484V7.06644C15.4999 7.85985 15.4999 8.25655 15.6543 8.5596C15.7901 8.82616 16.0069 9.04288 16.2734 9.1787C16.5765 9.33311 16.9732 9.33311 17.7666 9.33311H23.6182M18.3333 16.4163H6.99992M18.3333 22.083H6.99992M9.83325 10.7497H6.99992M15.4999 0.833008H8.13325C5.75303 0.833008 4.56292 0.833008 3.65379 1.29623C2.8541 1.70369 2.20394 2.35386 1.79647 3.15355C1.33325 4.06267 1.33325 5.25278 1.33325 7.63301V22.3663C1.33325 24.7466 1.33325 25.9367 1.79647 26.8458C2.20394 27.6455 2.8541 28.2957 3.65379 28.7031C4.56292 29.1663 5.75303 29.1663 8.13325 29.1663H17.1999C19.5801 29.1663 20.7703 29.1663 21.6794 28.7031C22.4791 28.2957 23.1292 27.6455 23.5367 26.8458C23.9999 25.9367 23.9999 24.7466 23.9999 22.3663V9.33301L15.4999 0.833008Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanSummary);
export default __webpack_public_path__ + "static/media/carePlanSummary.d0e43ff0abd0faf93c6c89e1dd8ac5f1.svg";
export { ForwardRef as ReactComponent };